jQuery(document).ready(function ($) {


    // Definiamo un adapter personalizzato per risolvere il bug di SelectWoo con l'HTML nelle opzioni selezionate
    // Questo è necessario per visualizzare correttamente i cerchi colorati nell'opzione selezionata
    // Vedi: https://github.com/woocommerce/selectWoo/issues/39#issuecomment-677431689
    $.fn.selectWoo.amd.define('CustomSingleSelectionAdapter', [
        'select2/utils',
        'select2/selection/single'
    ], function (Utils, SingleSelection) {
        const adapter = SingleSelection;

        // Override del metodo update per usare append invece di text
        adapter.prototype.update = function (data) {
            if (data.length === 0) {
                this.clear();
                return;
            }

            var selection = data[0];

            var $rendered = this.$selection.find('.select2-selection__rendered');
            var formatted = this.display(selection, $rendered);

            $rendered.empty().append(formatted);
            $rendered.attr('title', selection.title || selection.text);
        };

        return adapter;
    });

    // Otteniamo le variazioni
    const $form = $('.variations_form');
    if (!$form.length) {
        //console.log("Form delle variazioni non trovato");
    } else {
//console.log("Inizializzazione select prodotto variabile");
        function initProdottiVariabili() {
            /**
             * Funzione per ridurre le variazioni e mantenere solo i dati necessari
             */
            function reduceVariations(variations) {
                //console.log("Reducing variations...");
                return variations.map(function (item) {
                    return {
                        attributes: item.attributes || null,
                        is_in_stock: item.is_in_stock || null,
                        is_purchasable: item.is_purchasable || null,
                        variation_id: item.variation_id || null,
                    };
                });
            }

            const variationsData = $form.attr('data-product_variations');
            if (!variationsData) {
                //console.log("Nessun dato di variazioni trovato");
                return;
            }

            // Parsiamo e riduciamo le variazioni
            const variations = JSON.parse(variationsData);
            const reducedVariations = reduceVariations(variations);
            //console.log("Variazioni ridotte:", reducedVariations);

            // Inizializzazione variabili principali
            const attributeOrder = [];
            const selectsInfo = {};

            // Processiamo ogni select di attributo
            $('select[name^="attribute_"]').each(function (index) {
                const $original = $(this);
                const attrName = $original.attr('name');
                attributeOrder.push(attrName);

                // Nascondiamo la select originale
                $original.hide();
                //console.log(`Select originale nascosta: ${attrName}`);

                // Salviamo tutte le opzioni originali
                const options = [];
                $original.find('option').each(function () {
                    const $opt = $(this);
                    options.push({
                        value: $opt.val(),
                        text: $opt.text(),
                        selected: $opt.is(':selected')
                    });
                });
                //console.log(`Salvate ${options.length} opzioni originali per ${attrName}`);

                // Creiamo una nuova select
                const $newSelect = $('<select></select>');
                $newSelect
                    .attr('id', 'custom_' + attrName)
                    .addClass('custom-selectwoo')
                    .insertAfter($original)
                    .show();

                // Popoliamo la nuova select con tutte le opzioni originali
                options.forEach(opt => {
                    // Ottieni l'opzione originale per copiare tutti gli attributi data-*
                    const $originalOpt = $original.find('option[value="' + opt.value + '"]');
                    const $option = $('<option></option>')
                        .val(opt.value)
                        .text(opt.text);

                    // Copia tutti gli attributi data-* dall'opzione originale
                    if ($originalOpt.length) {
                        // Estrai tutti gli attributi data-* dall'opzione originale
                        $.each($originalOpt[0].attributes, function () {
                            if (this.name.startsWith('data-')) {
                                $option.attr(this.name, this.value);
                            }
                        });
                    }

                    if (opt.selected) {
                        $option.prop('selected', true);
                    }

                    $newSelect.append($option);
                });

                //console.log(`Nuova select creata per ${attrName}`);

                // Inizializzazione SelectWoo sulla nuova select
                $newSelect.selectWoo({
                    width: '100%',
                    minimumResultsForSearch: -1, // Disabilita la ricerca per select
                    placeholder: $original.data('placeholder') || 'Seleziona un\'opzione',
                    allowClear: false,
                    templateResult: formatOptionResult,
                    templateSelection: formatOptionSelection,
                    selectionAdapter: $.fn.selectWoo.amd.require('CustomSingleSelectionAdapter'), // Utilizziamo il nostro adapter personalizzato
                    sorter: function (data) {
                        // Ordina gli elementi in modo che quelli disponibili vengano prima
                        return data.sort(function (a, b) {
                            const aDisabled = $(a.element).prop('disabled');
                            const bDisabled = $(b.element).prop('disabled');

                            if (aDisabled && !bDisabled) {
                                return 1; // a va dopo b
                            } else if (!aDisabled && bDisabled) {
                                return -1; // a va prima di b
                            } else {
                                // Entrambi disabilitati o entrambi abilitati, manteniamo l'ordine originale
                                return 0;
                            }
                        });
                    }
                });

                // Memorizziamo riferimenti
                selectsInfo[attrName] = {
                    select: $newSelect,
                    originalSelect: $original, // Aggiungiamo il riferimento alla select originale
                    originalOptions: options
                };
            });


            /**
             * Formatta la visualizzazione delle opzioni nel dropdown
             */
            function formatOptionResult(data) {
                if (!data.id) return data.text; // Opzione vuota

                const $option = $(data.element);
                const isDisabled = $option.prop('disabled');

                // Verifichiamo se l'opzione ha attributi data-color-source e data-display-type
                const colorSource = $option.attr('data-color-source');
                const displayType = $option.attr('data-display-type');

                // Creiamo un contenitore flex per allineare il colore/immagine e il testo
                const $container = $('<div>').addClass('d-flex align-items-center gap-2');

                // Se abbiamo attributi di colore o immagine, aggiungiamo un elemento visivo
                if (colorSource && displayType) {
                    let style = '';

                    if (displayType === 'Color') {
                        // Per colore esadecimale
                        style = `background: ${colorSource}; border: 1px solid ${colorSource};`;
                    } else if (displayType === 'Image') {
                        // Per immagine
                        style = `background: url(${colorSource}); background-position: center; border: 1px solid lightgray;`;
                    }

                    if (style) {
                        const $circle = $('<span>')
                            .addClass('product-custom-select-dropdown-circle')
                            .attr('style', style);

                        $container.append($circle);
                    }
                }

                const $span = $('<span>').text(data.text);
                $container.append($span);

                // Se l'opzione è disabilitata, aggiungiamo stile ma la rendiamo comunque visibile
                if (isDisabled) {
                    $container.css({
                        'opacity': '0.6',
                        'text-decoration': 'line-through',
                        // 'background': '#f8f8f8',
                        'color': '#999'
                    });
                    $span.append(' <em>(non disponibile)</em>');
                }

                return $container;
            }

            /**
             * Formatta la visualizzazione dell'opzione selezionata
             * Deve restituire un oggetto jQuery per renderizzare correttamente l'HTML
             */
            function formatOptionSelection(data) {
                if (!data.id) return data.text; // Opzione vuota

                const $option = $(data.element);
                const isDisabled = $option.prop('disabled');

                // Verifichiamo se l'opzione ha attributi data-color-source e data-display-type
                const colorSource = $option.attr('data-color-source');
                const displayType = $option.attr('data-display-type');

                // Se non ci sono attributi di colore o immagine, restituisci solo il testo
                if (!colorSource || !displayType) {
                    return data.text;
                }

                // Creiamo un contenitore flex per allineare il colore/immagine e il testo
                // Usiamo esattamente la stessa struttura di formatOptionResult
                const $container = $('<div>').addClass('d-flex align-items-center gap-2');

                // Se abbiamo attributi di colore o immagine, aggiungiamo un elemento visivo
                let style = '';

                if (displayType === 'Color') {
                    // Per colore esadecimale
                    style = `background: ${colorSource}; border: 1px solid ${colorSource};`;
                } else if (displayType === 'Image') {
                    // Per immagine
                    style = `background: url(${colorSource}); background-position: center; border: 1px solid lightgray;`;
                }

                if (style) {
                    const $circle = $('<span>')
                        .addClass('product-custom-select-dropdown-circle')
                        .attr('style', style);

                    $container.append($circle);
                }

                const $span = $('<span>').text(data.text);

                $container.append($span);

                return $container;
            }

            /**
             * Ottiene gli attributi selezionati fino a un certo indice
             */
            function get_selected_attributes_up_to(index) {
                const selected = {};
                for (let i = 0; i <= index; i++) {
                    const attr = attributeOrder[i];
                    const val = selectsInfo[attr].select.val();
                    if (val) selected[attr] = val;
                }
                //console.log(`Attributi selezionati fino all'indice ${index}:`, selected);
                return selected;
            }

            /**
             * Ottiene i valori disponibili per un attributo in base agli attributi selezionati
             */
            function get_available_values_for(index, selectedAttrs) {
                const attrName = attributeOrder[index];
                const values = new Set();

                // Debug
                //console.log(`Cercando valori disponibili per ${attrName} con selezioni:`, selectedAttrs);

                reducedVariations.forEach(variation => {
                    if (!variation.attributes) return;

                    // Controlliamo se questa variazione corrisponde a tutti gli attributi selezionati
                    const match = Object.entries(selectedAttrs).every(([key, val]) => {
                        // Se la variazione ha un valore vuoto per questo attributo, è un "any" (jolly)
                        if (!variation.attributes[key] || variation.attributes[key] === '') {
                            return true;
                        }
                        return variation.attributes[key] === val;
                    });

                    // Se la variazione corrisponde e ha un valore per l'attributo corrente, aggiungilo
                    if (match && variation.attributes[attrName]) {
                        const value = variation.attributes[attrName];
                        if (!values.has(value)) {
                            values.add(value);
                        }
                    }
                });

                // Convertiamo in array di valori univoci (già garantito dal Set)
                const uniqueValues = [...values];
                //console.log(`Valori disponibili per ${attrName}:`, uniqueValues);
                return uniqueValues;
            }

            /**
             * Aggiorna le dropdown successive a quella cambiata
             */
            function update_next_dropdowns(index) {
                //console.log(`Aggiornamento dropdown a partire dall'indice ${index}`);

                for (let i = index; i < attributeOrder.length; i++) {
                    const attr = attributeOrder[i];
                    const $select = selectsInfo[attr].select;
                    const selectedAttrs = get_selected_attributes_up_to(i - 1);
                    const available = get_available_values_for(i, selectedAttrs);

                    //console.log(`Aggiornamento select: ${attr}, Valori disponibili:`, available);

                    // Distruggiamo SelectWoo prima di modificare le opzioni
                    try {
                        if ($select.data('select2')) {
                            $select.selectWoo('destroy');
                        }
                    } catch (e) {
                        console.warn("Errore nella destroy di SelectWoo", e);
                    }

                    // Salva il valore corrente prima di aggiornare le opzioni
                    const currentValue = $select.val();

                    // Aggiorniamo le opzioni: impostiamo disabled su quelle non disponibili
                    $select.find('option').each(function () {
                        const $option = $(this);
                        const val = $option.val();
                        if (!val) return; // Ignoriamo l'opzione vuota "Scegli un'opzione"

                        if (!available.includes(val)) {
                            $option.prop('disabled', true).attr('data-unavailable', 'true');

                            // Se questa opzione era selezionata ma ora non è disponibile, resettiamo
                            if ($option.is(':selected')) {
                                $select.val('');
                            }
                        } else {
                            $option.prop('disabled', false).removeAttr('data-unavailable');
                        }
                    });

                    // Ripristina il valore se era ancora disponibile
                    if (currentValue && available.includes(currentValue)) {
                        $select.val(currentValue);
                    }

                    // Reinizializziamo SelectWoo con il template personalizzato e ordinamento personalizzato
                    $select.selectWoo({
                        width: '100%',
                        minimumResultsForSearch: -1,
                        placeholder: $select.data('placeholder') || 'Seleziona un\'opzione',
                        allowClear: false,
                        templateResult: formatOptionResult,
                        templateSelection: formatOptionSelection,
                        selectionAdapter: $.fn.selectWoo.amd.require('CustomSingleSelectionAdapter'), // Utilizziamo il nostro adapter personalizzato
                        sorter: function (data) {
                            // Ordina gli elementi in modo che quelli disponibili vengano prima
                            return data.sort(function (a, b) {
                                const aDisabled = $(a.element).prop('disabled');
                                const bDisabled = $(b.element).prop('disabled');

                                if (aDisabled && !bDisabled) {
                                    return 1; // a va dopo b
                                } else if (!aDisabled && bDisabled) {
                                    return -1; // a va prima di b
                                } else {
                                    // Entrambi disabilitati o entrambi abilitati, manteniamo l'ordine originale
                                    return 0;
                                }
                            });
                        }
                    });

                    // Notifichiamo del cambio programmatico
                    $select.trigger('change.select2', [true]);
                }
            }

            /**
             * Verifica se la combinazione corrente è valida e trova la variazione corrispondente
             * Restituisce la variazione se trovata, altrimenti false
             */
            function findCurrentVariation() {
                // Otteniamo tutti gli attributi selezionati
                const selectedAttrs = {};
                for (const attr of attributeOrder) {
                    const val = selectsInfo[attr].select.val();
                    if (!val) return false; // Se manca un attributo, non è una combinazione valida
                    selectedAttrs[attr] = val;
                }

                // Cerchiamo la variazione corrispondente
                for (const variation of variations) {
                    if (!variation.attributes) continue;

                    // Controlliamo se tutti gli attributi selezionati corrispondono
                    const match = Object.entries(selectedAttrs).every(([key, val]) => {
                        if (!variation.attributes[key] || variation.attributes[key] === '') {
                            return true;
                        }
                        return variation.attributes[key] === val;
                    });

                    if (match) {
                        return variation;
                    }
                }

                return false;
            }

            /**
             * Forza un trigger diretto dell'evento found_variation di WooCommerce
             */
            function forceFoundVariation() {
                const variation = findCurrentVariation();

                if (variation) {
                    //console.log("Variazione valida trovata, trigger diretto dell'evento found_variation", variation);

                    // Trigger diretto dell'evento found_variation di WooCommerce
                    $form.trigger('found_variation', [variation]);

                    // Inoltre, proviamo a ripristinare il bottone "Aggiungi al carrello"
                    //     $('.single_add_to_cart_button').prop('disabled', false).removeClass('disabled wc-variation-is-unavailable');

                    return true;
                }

                return false;
            }

            /**
             * Listener per il cambio della select
             */
            $('.custom-selectwoo').on('change', function (e, triggeredProgrammatically) {
                if (triggeredProgrammatically) return; // Preveniamo loop infiniti

                const id = $(this).attr('id');
                const attrName = id.replace('custom_', '');
                const index = attributeOrder.indexOf(attrName);
                const val = $(this).val();

                //console.log(`Select ${attrName} cambiata. Valore: ${val}`);

                // SYNC: Aggiorniamo il valore nella select originale di WooCommerce
                const $originalSelect = selectsInfo[attrName].originalSelect;
                $originalSelect.val(val);

                // SYNC: Triggeriamo l'evento change sulla select originale
                setTimeout(function () {
                    // Usiamo dispatchEvent per assicurarci che WooCommerce riceva l'evento
                    if ($originalSelect[0].dispatchEvent) {
                        const event = new Event('change', {bubbles: true});
                        $originalSelect[0].dispatchEvent(event);
                    }

                    // Dopo un breve ritardo, verifichiamo se la combinazione è valida
                    // e forziamo direttamente l'evento found_variation se necessario
                    setTimeout(function () {
                        // Verifica se la combinazione è valida e, in caso, forza l'evento found_variation
                        forceFoundVariation();
                    }, 150);
                }, 10);

                // Aggiorniamo le dropdown successive
                update_next_dropdowns(index + 1);
            });

            /**
             * Preveniamo il click sulle opzioni disabilitate
             */
            $(document).on('mousedown touchstart', '.select2-results__option[aria-disabled=true]', function (e) {
                e.preventDefault();
                e.stopPropagation();
                alert('Questa combinazione non è disponibile con le opzioni selezionate.');
                return false;
            });

            // Inizializzazione iniziale
            setTimeout(function () {
                //console.log("Inizializzazione iniziale delle select");
                update_next_dropdowns(0);
                //console.log("Sistema varianti con SelectWoo inizializzato");

                // Inizializzazione delle select per varianti semplici
                initSelectProdottiScorporati();
            }, 100);

            /*
            * SHOW/HIDE PREZZO PRODOTTO VARIABILE
            */
            var $priceRange = $('.single-product .summary > .price');
            var $variationForm = $('.variations_form');


            // Mostra il range di prezzo quando nessuna variante è selezionata
            $form.on('reset_data', function () {
                $('.woocommerce-variation-price').hide();
                $priceRange.show();
            });


            $form.on('found_variation', function (event, variation) {
                // Nascondiamo il range di prezzo quando c'è una variante selezionata

                $priceRange.hide();
                if (variation.display_price) {
                    $('.woocommerce-variation-price').show();
                }
                /*
               * GESTIONE STOCK
               */
                const $availableQuantityCircle = $('.product-available-quantity-circle');
                const $stockMessage = $('#product-stock-message');
                const lowQuantity = parseInt($stockMessage.data('low-quantity'));
                const mediumQuantity = parseInt($stockMessage.data('medium-quantity'));
                const colorsQuantity = $stockMessage.data('quantity-color');

                if (variation && variation.is_in_stock && colorsQuantity) {
                    const stockQuantity = variation.max_qty || 0;
                    let quantityColor = colorsQuantity.green; // Default

                    // Definisci il colore in base alla quantità di stock
                    if (stockQuantity < lowQuantity) {
                        quantityColor = colorsQuantity.red;
                    } else if (stockQuantity < mediumQuantity) {
                        quantityColor = colorsQuantity.orange;
                    }
                    // Aggiorna il messaggio e il colore
                    $availableQuantityCircle.css('fill', quantityColor);
                    $stockMessage.html(`Disponibilità: ${stockQuantity} pezzi.`);
                } else {
                    // Prodotto non disponibile
                    $stockMessage.html('Questa variazione non è disponibile.');
                }

                /*
                * PREZZO UNITARIO DELLE VARIANTI CON PIU' DI UNA QUANTITA'
                */
                // if (variation.prezzo_unitario) {
                //     $('.woocommerce-variation-price').append(
                //         '<div class="unit-price product-price-line-through-color font-dm-sans">Prezzo unitario: ' + variation.prezzo_unitario + '</div>'
                //     );
                // }

                /*
                * GESTIONE EAN, SKU, OLD_PRODUCT_ID E ALTERNATIVE_TITLE PER LE VARIANTI
                */

                let ean = variation.ean || ''; // Default se EAN non è presente
                let sku = variation.sku || ''; // Default se SKU non è presente
                let perfSku = variation.perf_sku || ''; // Default se perf_sku non è presente
                let alternativeTitle = variation.alternative_title || ''; // Default se alternative_title non è presente

                $('.product-details-item-value.ean').text(ean); // Aggiorna EAN
                $('.product-details-item-value.sku').text(sku); // Aggiorna SKU
                $('.product-details-item-value.perf-sku').text(perfSku); // Aggiorna perf_sku
                $('.page-product-name.alternative-title').text(alternativeTitle); // Aggiorna alternative_title
            });

            // Variabile per tenere traccia dell'ultima operazione e evitare log duplicati
            let lastHideTimestamp = 0;

            // Gestione per quando la combinazione non è valida
            $form.on('hide_variation', function () {
                // Controlliamo se è passato abbastanza tempo dall'ultimo evento hide_variation
                // per evitare log duplicati in rapida successione (meno di 100ms)
                const now = Date.now();
                if (now - lastHideTimestamp < 200) {
                    // Eseguiamo comunque il reset dei campi
                    resetFields();
                    return; // Ma non mostriamo il log
                }

                // Aggiorniamo il timestamp
                lastHideTimestamp = now;

                //console.log("Combinazione non valida, resetto i valori di EAN, SKU, perfSku e alternativeTitle");
                resetFields();
            });

            // Funzione di reset dei campi
            function resetFields() {
                // Resettiamo i campi
                $('.product-details-item-value.ean').text(''); // Resetta EAN
                $('.product-details-item-value.sku').text(''); // Resetta SKU
                $('.product-details-item-value.perf-sku').text(''); // Resetta perf_sku
                $('.page-product-name.alternative-title').text(''); // Resetta alternative_title
            }
        }
initProdottiVariabili();

    }


    /*
     * SELECT VARIANTI PAGINA PRODOTTO SEMPLICE (prodotto scorporato)
     * Inizializzazione SelectWoo per le varianti semplici
     */
    function initSelectProdottiScorporati() {
        const $simpleVariationSelect = $('.simple-variation-selectwoo');
        //console.log("Inizializzazione SelectWoo per prodotti scorporati, trovati elementi:", $simpleVariationSelect.length);

        if ($simpleVariationSelect.length) {
            try {
                // Inizializziamo SelectWoo con i dati già disponibili nell'elemento select
                $simpleVariationSelect.selectWoo({
                    width: '100%',
                    minimumResultsForSearch: -1, // Disabilita la ricerca
                    templateResult: formatSimpleVariationResult,
                    templateSelection: formatSelectedOptionProdottoScorporato,
                    selectionAdapter: $.fn.selectWoo.amd.require('CustomSingleSelectionAdapter') // Utilizziamo il nostro adapter personalizzato
                });

                // Gestiamo il cambio di opzione
                $simpleVariationSelect.on('change', function () {
                    const selectedUrl = $(this).val();
                    if (selectedUrl && selectedUrl !== '#') {
                        window.location.href = selectedUrl;
                    }
                });

                //console.log("SelectWoo per varianti semplici inizializzato con successo");
            } catch (error) {
                console.error("Errore nell'inizializzazione di SelectWoo per varianti semplici:", error);
            }
        }


        /**
         * Formatta la visualizzazione delle opzioni nel dropdown per varianti semplici
         */
        function formatSimpleVariationResult(data) {
            if (!data.id) return data.text; // Opzione vuota

            const $option = $(data.element);
            const isOutOfStock = $option.attr('data-out-of-stock') === 'true';

            const $container = $('<div>').addClass('d-flex align-items-center gap-2');
            const $span = $('<span>').text(data.text);
            $container.append($span);

            // Se è esaurito, aggiungiamo stili
            if (isOutOfStock) {
                $container.css({
                    'opacity': '0.7',

                    'color': '#888'
                });
            }

            return $container;
        }

        /**
         * Formatta la visualizzazione dell'opzione selezionata per varianti semplici
         */
        function formatSelectedOptionProdottoScorporato(data) {
            if (!data.id) return data.text; // Opzione vuota

            const $option = $(data.element);
            const isOutOfStock = $option.attr('data-out-of-stock') === 'true';

            // Creiamo un contenitore per l'elemento selezionato
            const $container = $('<span>');
            $container.text(data.text);

            // Aggiungiamo eventuali stili se è esaurito
            if (isOutOfStock) {
                $container.css({
                    'opacity': '0.7',
                    // 'background': '#f8f8f8',
                    'color': '#888'
                });
            }

            return $container;
        }

    }


    if ($('.simple-variation-selectwoo').length)
        initSelectProdottiScorporati();
});